// extracted by mini-css-extract-plugin
export var circle = "_9o-1";
export var exitConfirmationModal = "_9o-5";
export var iframe = "_9o-0";
export var offline = "_9o-3";
export var online = "_9o-2";
export var workstationSelectError = "_9o-4";